{
  "calibrations": {
    "title": "Calibrations",
    "create_new": "Run New Calibration",
    "serials": "Serials",
    "from": "From",
    "to": "To",
    "manage_actions": {
      "transfer": "Transfer",
      "reset": "Reset",
      "identify": "Identify",
      "run": "Run New Calibration"
    }
  }
}